import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/contact.css';

const ContactForm: React.FC = () => {
  const form = useRef<HTMLFormElement>(null);
  const submitBtn = useRef<HTMLButtonElement>(null);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.current || !submitBtn.current) return;

    emailjs
      .sendForm('service_2g40c6q', 'template_dx8srnq', form.current, 'KNshdyHxDVE80s1gd')
      .then(
        () => {
          submitBtn.current!.textContent = 'Sent Successfully! 🎉';
          submitBtn.current!.style.background = 'var(--color-success)';
          if (form.current) form.current.reset();
          setTimeout(() => {
            submitBtn.current!.textContent = 'Send Message';
            submitBtn.current!.style.background = 'var(--color-accent)';
          }, 3000);
        },
        () => {
          submitBtn.current!.textContent = 'Error - Try Again';
          submitBtn.current!.style.background = '#ef4444';
          setTimeout(() => {
            submitBtn.current!.textContent = 'Send Message';
            submitBtn.current!.style.background = 'var(--color-accent)';
          }, 3000);
        }
      );
  };

  return (
    <div id="contact" className="contact-container">
      <div className="reveal">
        <h1>Get In Touch</h1>
        <p className="contact-subtitle">Have a question or want to work together? Let me know!</p>
        <form ref={form} onSubmit={sendEmail}>
          <label>Name</label>
          <input type="text" name="user_name" required />
          <label>Email</label>
          <input type="email" name="user_email" required />
          <label>Message</label>
          <textarea name="message" required />
          <button ref={submitBtn} className="submit-btn" type="submit">
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;


